var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FDF5EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2134 36.5997C66.42 41.803 66.42 50.2463 61.2134 55.453L42.3567 74.3097C41.0567 75.6097 38.9434 75.6097 37.6434 74.3097L18.7867 55.453C13.58 50.2463 13.58 41.803 18.7867 36.5963C23.9934 31.3897 32.4367 31.3897 37.6434 36.5963L39.9967 38.953L42.3567 36.5963C47.5634 31.3897 56.0067 31.3897 61.2134 36.5963V36.5997ZM23.5 41.3063C20.9 43.9097 20.9 48.133 23.5 50.7363L40 67.2363L56.5001 50.7363C59.1001 48.133 59.1001 43.9097 56.5001 41.3063C53.8967 38.7063 49.6734 38.7063 47.0667 41.313L39.9934 48.373L32.9267 41.3063C30.3267 38.7063 26.1034 38.7063 23.5 41.3063V41.3063ZM40 3.33301C47.3667 3.33301 53.3334 9.29967 53.3334 16.6663C53.3334 24.033 47.3667 29.9997 40 29.9997C32.6334 29.9997 26.6667 24.033 26.6667 16.6663C26.6667 9.29967 32.6334 3.33301 40 3.33301ZM40 9.99967C36.3167 9.99967 33.3334 12.983 33.3334 16.6663C33.3334 20.3497 36.3167 23.333 40 23.333C43.6834 23.333 46.6667 20.3497 46.6667 16.6663C46.6667 12.983 43.6834 9.99967 40 9.99967Z",
    fill: "#115896"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiPortal);
export default __webpack_public_path__ + "static/media/MiPortal.6f4283949d6cfc2b4ab374a81d11df1d.svg";
export { ForwardRef as ReactComponent };